export default [
  {
    path: '/app/welcome',
    name: 'WelcomePage',
    component: () => import('@/views/Welcome/Index.vue'),
    meta: {
      pageTitle: 'Hoş Geldiniz',
      breadcrumb: [
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'WELCOME_PAGE',
      action: 'read',
    },
  },
]
